module.exports = __webpack_public_path__ + "img/bre7.29524133.png";